module.exports = __webpack_public_path__ + "static/media/1.f9f94385.png";